// import ScrollMagic from 'scrollmagic';
// import { TweenMax, TimelineMax, Linear } from 'gsap';
// import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import lookbookPlayer from './player';
// import '../../../../../node_modules/scrollmagic/scrollmagic/minified/plugins/animation.gsap.min';
// import '../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

const initFadeInUp = () => {
  const scrollmagicController = new ScrollMagic.Controller();
  const $revealElements = $('.fadeInUp');

  _.each($revealElements, (revealElement) => {
    // console.log('revealElement', revealElement, document.getElementsByClassName("fadeInUp")[0]);
    // const revealElementHtml = revealElement.get(0);
    new ScrollMagic.Scene({
      // y value not modified, so we can use element as trigger as well
      triggerElement: revealElement,
      // start a little later
      offset: -$('.main-nav--desktop').height(),
      triggerHook: 0.8,
      reverse: false,
    })
      // add class toggle
      .setClassToggle(revealElement, 'animated')
      // .addIndicators({name: "Fade " + (i + 1) }) // add indicators (requires plugin)
      .addTo(scrollmagicController);
  });
};

const initParallax = () => {
  const parallax_controller = new ScrollMagic.Controller(
    {
      globalSceneOptions: {
        triggerHook: 'onEnter',
        duration: '200%',
      },
    },
  );

  _.each($('.parallax'), (parallax_element) => {
    const timeline = new TimelineMax();
    const $trig = $(parallax_element).parent();
    const parallax_value = $(parallax_element).data('parallax');
    const speed = `${Number(parallax_value) * 50}%`;
    // const fadeout = TweenMax.to(parallax_element, 0.2, {alpha: 1, ease: Linear.easeNone});
    // const fadein = TweenMax.from(parallax_element, 1, { opacity: 1 });
    const fadeInFrom = TweenMax.from(parallax_element, 1, { autoAlpha: 0 });
    const fadeInTo = TweenMax.to(parallax_element, 0.8, { autoAlpha: 1 });

    timeline.add(fadeInFrom).add(fadeInTo);
    
    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(parallax_element, { y: speed, ease: Linear.easeNone })
      .addTo(parallax_controller);

    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(timeline)
      .addTo(parallax_controller);
  });
};

const initParallaxOffset = () => {
  const parallax_controller = new ScrollMagic.Controller(
    {
      globalSceneOptions: {
        triggerHook: 'onEnter',
        duration: '70%',
      },
    },
  );

  _.each($('.parallaxoffset'), (parallax_element) => {
    const timeline = new TimelineMax();
    const $trig = $(parallax_element).parent();
    const parallax_value = $(parallax_element).data('parallax');
    const speed = `${Number(parallax_value) * 1}%`;
    const fadein = TweenMax.from(parallax_element, 1, {opacity: 0});
    timeline.add(fadein);

    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(parallax_element, { y: speed, ease: Linear.easeNone })
      .addTo(parallax_controller);

    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(timeline)
      .addTo(parallax_controller);
  });
};

const initParallaxX = () => {
  const parallax_controller = new ScrollMagic.Controller(
    {
      globalSceneOptions: {
        triggerHook: '1',
        duration: '100%',
      },
    },
  );

  _.each($('.parallaxX'), (parallax_element) => {
    const timeline = new TimelineMax();
    const $trig = $(parallax_element).parent();
    const parallax_value = $(parallax_element).data('parallaxX');
    const speed = `${Number(parallax_value) * 1}%`;
    const fadeout = TweenMax.to(parallax_element, 0.1, {alpha: 1});
    const fadein = TweenMax.from(parallax_element, 0.5, {opacity: 0});
    timeline.add(fadein).add(fadeout);

    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(parallax_element, { y: speed, ease: Linear.easeNone })
      .addTo(parallax_controller);

    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(timeline)
      .addTo(parallax_controller);
  });
};

const initPanels = () => {
  const panel_controller = new ScrollMagic.Controller();
  let anim_x = [0, 33, 66];

  if (window.theme.breakpoints.current === 'mobile') {
    anim_x = [0, 0, 0];
  }

  _.each($('.panels'), (panels_element) => {
    const $trig = $(panels_element).parent();
    const $panel_items = $trig.find('.panel');
    const timeline = new TimelineMax();

    if ($panel_items.length === 4) {
      // define movement of panels
      _.each($panel_items, (panel, i) => {
        // 1st element doesn't have any animation
        if (i > 0) {
          timeline.fromTo(panel, 1, { x: '100%' }, { x: `${anim_x[i - 1]}%`, ease: Linear.easeNone });
        }
      });

      // create scene to pin and link animation
      new ScrollMagic.Scene({
        triggerElement: $trig.get(0),
        triggerHook: 'onLeave',
        duration: '300%',
        // offset: -$('.main-nav--desktop').height(),
      })
        .setPin($trig.get(0))
        .setTween(timeline)
        .addTo(panel_controller);
    }
  });
};

const initScaleY = () => {
  const scaleY_controller = new ScrollMagic.Controller();

  _.each($('.scaleY'), (scaleY_element) => {
    const $trig = $(scaleY_element);
    const tween = TweenMax.to(scaleY_element, 1, { scale: 1.5, opacity: 1, ease: Linear.easeNone });

    // create scene to pin and link animation
    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      triggerHook: 0,
      duration: '100%',
      offset: -$('.main-nav--desktop').height(),
    })
      .setTween(tween)
      .setPin(scaleY_element)
      .addTo(scaleY_controller);
  });
};

const initZoomY = () => {
  const zoomY_controller = new ScrollMagic.Controller();

  _.each($('.zoomY'), (zoomY_element) => {
    const $trig = $(zoomY_element);
    const tween = TweenMax.to(zoomY_element, 1, { scale: 1.8, opacity: 1, ease: Linear.easeNone });

    // create scene to pin and link animation
    new ScrollMagic.Scene({
      triggerElement: $trig.get(0),
      triggerHook: 0,
      duration: '80%',
      // offset: -$('.main-nav--desktop').height(),
    })
      .setPin($trig.get(0))
      .setTween(tween)
      .addTo(zoomY_controller);
  });
};

const initFixed = () => {
  // if (window.theme.breakpoints.current === 'mobile') {
  //   return;
  // }

  const fixed_controller = new ScrollMagic.Controller();

  _.each($('.fixedSM'), (fixed_element) => {
    const trig_class = $(fixed_element).data('fixed-type');
    // const sm_duration = fixed_element.data('duration');

    let header_height = 0;
    if (window.theme.breakpoints.current === 'mobile') {
      // Remove 20px due to the height change from unscroll to scrolled on real mobile devices
      const announcement_height = $('.announcement-bar--mobile').length ? $('.announcement-bar--mobile').outerHeight() : 0;
      header_height = $('.main-nav--mobile').outerHeight() + announcement_height - 20;
    } else {
      const announcement_height = $('.announcement-bar--desktop').length ? $('.announcement-bar--desktop').outerHeight() : 0;
      header_height = $('.shopify-section.header').outerHeight() - announcement_height;
    }

    let sm_duration;
    switch (trig_class) {
      case 'vertical-col-2':
      case 'column-1-of-3':
        sm_duration = '200%';
        break;

      case 'horizontal-img-right-fixed-with-scroll-text':
      case 'horizontal-img-left-fixed-with-scroll-text':
        sm_duration = (window.theme.breakpoints.current === 'mobile') ? `${125 - ((header_height / $(window).height()) * 100)}%` : `${150 - ((header_height / $(window).height()) * 100)}%`;
        break;

      // Stays fixed on top but scrolls together with the right image after the text disappears
      case 'img-col-2':
        sm_duration = (window.theme.breakpoints.current === 'mobile') ? '25%' : '50%';

        if ($(fixed_element).hasClass('center-image-scroll')) {
          sm_duration = (window.theme.breakpoints.current === 'mobile') ? `${75 - ((header_height / $(window).height()) * 100)}%` : `${85 - ((header_height / $(window).height()) * 100)}%`;
        }
        break;

      case 'lg-img-fixed':
        sm_duration = `${100 - ((header_height / $(window).height()) * 100)}%`;
        break;

      case 'horizontal-img-right':
      case 'horizontal-img-left':
      case 'right-img-fixed':
      case 'left-img-fixed':
      case 'vertical-col-1':
      case 'column-2-of-3':
        sm_duration = (window.theme.breakpoints.current === 'mobile') ? '150%' : '100%';
        break;

      default:
        sm_duration = $(window).height();
    }

    let push_followers = false;
    if ($(fixed_element).hasClass('fixed-text')) {
      push_followers = true;
    }

    if ($(fixed_element).hasClass('fixed-text') && $(fixed_element).parent().data('block-type') === 'full_image_v2') {
      sm_duration = `${100 - ((header_height / $(window).height()) * 100)}%`;
      push_followers = false;
      // exclude_nav = header_height / $(window).height();
    }
    
    let exclude_nav = 0;
    if ($(fixed_element).hasClass('fixed-text')) {
      exclude_nav = 0;
    } else {
      if ($(fixed_element).hasClass('center-image-scroll')) {
        header_height += ($(window).height() - header_height - $(fixed_element).height()) / 2;
      }
      
      exclude_nav = header_height / $(window).height();
    }

    const scene_options = {
      triggerElement: $(fixed_element).get(0),
      duration: sm_duration,
      triggerHook: exclude_nav,
      reverse: true,
    };

    new ScrollMagic.Scene(scene_options)
      .setPin($(fixed_element).get(0), { pushFollowers: push_followers })
      .addTo(fixed_controller);
  });
};

export default () => {
  // ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  
  // Scrollmagic animations
  initFadeInUp();
  initParallax();
  initParallaxOffset();
  initParallaxX();
  initScaleY();
  initZoomY();
  initFixed();

  // if (window.theme.breakpoints.current !== 'mobile') {
    initPanels();
  // }

  // Video player
  lookbookPlayer();
};
